



































import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';

import { Condition } from '@app/promotionHub/shared/types/Condition';
import { getCustomContentLabel } from '@app/promotionHub/bonuses/utils/presentation';
import { useCustomConditionsPreview } from '@app/promotionHub/bonuses/composables/bonuses';
import { BonusKind } from '@core/models/bonus/Bonus';
import { SdsButtonText } from '@superbet-group/web.lib.ui-components';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';

export default defineComponent({
    name: 'CustomConditionsPreview',
    emits: [
        'toggleDetails',
        'update:areDetailsVisible',
    ],
    props: {
        customConditions: {
            type: Array as PropType<Condition[]>,
            required: false,
            default: () => [],
        },
        kind: {
            type: String as PropType<BonusKind>,
            required: true,
        },
    },
    setup(props, { emit }) {
        const visibleCustomConditionsCount = 1;

        const customConditionsPreview = useCustomConditionsPreview(props.customConditions, props.kind);
        const hiddenCustomConditionsIndicator = `+${customConditionsPreview.length - visibleCustomConditionsCount}`;

        function toggleDetails() {
            emit('update:areDetailsVisible', true);
            emit('toggleDetails');
        }

        return {
            visibleCustomConditionsCount,
            isMoreButtonVisible: customConditionsPreview.length - visibleCustomConditionsCount >= 1,
            hiddenCustomConditionsIndicator,
            customConditionsPreview,
            buttonSize: computed(() => isMobileLayout() ? 'sm' : 'md'),
            getCustomContentLabel,
            toggleDetails,
        };
    },
    components: { SdsButtonText },
});
